// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SiU-","title":"styles_title__2L9gq"};